module.exports = __webpack_public_path__ + "images/morning_coffee/icon-twitter.png";